@if (formattedCellset) {
    @if (type === "data") {
        <key-analytics-data-table
            [cellset]="formattedCellset"
            [selected]="selectedMeasure"
            class="flex-1"
            (onHeaderClick)="emitMeasureSelection($event)"
        ></key-analytics-data-table>
    }
    @if (type === "pivot") {
        <key-analytics-pivot-table
            [cellset]="formattedCellset"
            [selected]="selectedMeasure"
            class="flex-1"
            (onHeaderClick)="emitMeasureSelection($event)"
        ></key-analytics-pivot-table>
    }
}
